export const calc = {
  add(num1, num2) {
    // 加
    var r1, r2, m, n;
    try {
      r1 = num1.toString().split('.')[1].length;
    } catch (e) {
      r1 = 0;
    }
    try {
      r2 = num2.toString().split('.')[1].length;
    } catch (e) {
      r2 = 0;
    }
    m = Math.pow(10, Math.max(r1, r2));
    n = r1 >= r2 ? r1 : r2;
    return ((num1 * m + num2 * m) / m).toFixed(n);
  },
  // 减
  sub(num1, num2) {
    var r1, r2, m, n;
    try {
      r1 = num1.toString().split('.')[1].length;
    } catch (e) {
      r1 = 0;
    }
    try {
      r2 = num2.toString().split('.')[1].length;
    } catch (e) {
      r2 = 0;
    }
    n = r1 >= r2 ? r1 : r2;
    m = Math.pow(10, Math.max(r1, r2));
    return ((num1 * m - num2 * m) / m).toFixed(n);
  },
  // 乘
  mul(num1, num2) {
    var m = 0;
    try {
      if (
        num1.toString().split('.')[1] &&
        num1.toString().split('.')[1].length
      ) {
        m += num1.toString().split('.')[1].length;
      }
    } catch (e) {
      throw new Error(e);
    }
    try {
      if (
        num2.toString().split('.')[1] &&
        num2.toString().split('.')[1].length
      ) {
        m += num2.toString().split('.')[1].length;
      }
    } catch (e) {
      throw new Error(e);
    }
    return (
      (Number(num1.toString().replace('.', '')) *
        Number(num2.toString().replace('.', ''))) /
      Math.pow(10, m)
    );
  },
  // 除
  div(arg1, arg2) {
    var t1 = 0;
    var t2 = 0;
    var r1, r2;
    try {
      if (
        arg1.toString().split('.')[1] &&
        arg1.toString().split('.')[1].length
      ) {
        t1 = arg1.toString().split('.')[1].length;
      }
    } catch (e) {
      throw new Error(e);
    }
    try {
      if (
        arg2.toString().split('.')[1] &&
        arg2.toString().split('.')[1].length
      ) {
        t2 = arg2.toString().split('.')[1].length;
      }
    } catch (e) {
      throw new Error(e);
    }
    r1 = Number(arg1.toString().replace('.', ''));
    r2 = Number(arg2.toString().replace('.', ''));
    return (r1 / r2) * Math.pow(10, t2 - t1);
  },
};



// WEBPACK FOOTER //
// ./src/utils/calc.js